<template>
  <div class="cover"></div>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.cover {
  height: 300px;
  background: $gradient1;
}
</style>